exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-sales-recon/form-sales-recon-row/form-sales-recon-row.component.scss
// module id = ../../../../../src/app/views/daily-recon/shifts-recon/components/form-sales-recon/form-sales-recon-row/form-sales-recon-row.component.scss
// module chunks = main